<p>cancel-sale-simulator works!</p>
